import { render, staticRenderFns } from "./Service1920.vue?vue&type=template&id=3e343554&scoped=true"
import script from "./Service1920.vue?vue&type=script&lang=js"
export * from "./Service1920.vue?vue&type=script&lang=js"
import style0 from "./Service1920.vue?vue&type=style&index=0&id=3e343554&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e343554",
  null
  
)

export default component.exports